import React, {useState, useEffect} from 'react'
import './Overview.css'
import UserService from '../../../../services/user'
import useServices from '../../../../utils/hooks/useServices'
import MasterServices from '../../../../services/master'
import {useSearchParams} from 'react-router-dom'
import {PageTitle} from '_metronic/layout/core'

import {dateFormat} from '../../../../thesis-and-dissertations/helpers/helper'

export function Overview() {
  const [searchParams] = useSearchParams()
  const [data, setData] = useState<any>({})
  const [user] = useServices(
    searchParams.get('alumni') ? MasterServices.showUser : UserService.getProfile,
    searchParams.get('alumni')
  )

  useEffect(() => {
    if (searchParams.get('alumni')) {
      setData(user?.data)
    } else {
      setData(user)
    }
  }, [user])
  return (
    <div className='d-grid gap-10'>
      {localStorage.getItem('role') == 'Alumni' && (
        <PageTitle
          breadcrumbs={[
            {
              title: 'Dashboard',
              path: '/dashboard',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '/',
              path: '',
              isSeparator: false,
              isActive: false,
            },
          ]}
        >
          Ringkasan
        </PageTitle>
      )}
      <h4>Ringkasan</h4>
      <div className='d-grid gap-10'>
        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='d-grid gap-4'>
              <div className='row'>
                <div className='col-md-6 p-2'>
                  <h5>Deskripsi Singkat</h5>
                </div>
                <div className='col-md-6'></div>
                <div className='col-md-12 p-2'>
                  <p> {data?.detail?.user_details_description ?? '-'} </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='card-custom'>
                <div className='d-grid gap-4'>
                  <h5>Informasi Personal</h5>
                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-4'>
                        <p>NIK</p>
                      </div>
                      <div className='col-md-8'>
                        <p className='fw-bold'>
                          {data?.detail?.user_details_id_card_number ?? '-'}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-4'>
                        <p>Tanggal Lahir</p>
                      </div>
                      <div className='col-md-8'>
                        <p className='fw-bold'>
                          {data?.detail?.dob ? dateFormat(data?.detail?.dob) : '-'}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-4'>
                        <p>Jenis Kelamin</p>
                      </div>
                      <div className='col-md-8'>
                        <p className='fw-bold'>
                          {data?.detail?.user_details_gender == 1 ? 'Pria' : 'Wanita'}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='card-custom'>
                <div className='d-grid gap-4'>
                  <h5>Informasi Kontak</h5>
                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-4'>
                        <p>Email</p>
                      </div>
                      <div className='col-md-8'>
                        <p className='fw-bold'>{data?.email ?? '-'}</p>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-4'>
                        <p>Handphone</p>
                      </div>
                      <div className='col-md-8'>
                        <p className='fw-bold'>
                          {data?.detail
                            ? `+${data?.detail?.user_details_code_phone} ${data?.detail?.user_details_phone}`
                            : '-'}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-4'>
                        <p>Handphone Alt.</p>
                      </div>
                      <div className='col-md-8'>
                        <p className='fw-bold'>
                          {data?.detail
                            ? `+${data?.detail?.user_details_wa_code_phone}  ${data?.detail?.user_details_wa_phone}`
                            : '-'}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='d-grid gap-4'>
              <h5>INFORMASI ALAMAT</h5>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='col-md-4'>
                      <p>Alamat KTP</p>
                    </div>
                    <div className='col-md-8'>
                      {data?.addresses?.map((item: any, key: any) => (
                        <p key={key} className='fw-bold'>
                          {item.user_addresses_is_domicile == 0 ? item.user_addresses ?? '-' : '-'}
                        </p>
                      ))}
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='col-md-4'>
                      <p>Alamat Domisili</p>
                    </div>
                    <div className='col-md-8'>
                      {data?.addresses?.map((item: any, key: any) => (
                        <p key={key} className='fw-bold'>
                          {item.user_addresses_is_domicile == 1 ? item.user_addresses ?? '-' : '-'}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='d-grid gap-4'>
              <h5>INFORMASI PENDIDIKAN</h5>
              {data?.educations?.map((item: any, key: any) => (
                <div key={key}>
                  <p className='fw-bold'>{item?.university?.universities_name}</p>
                  <p>
                    {item.degree?.degrees_name}, {item.major?.majors_name}
                  </p>
                  <p>
                    {item.user_educations_start_date} -{' '}
                    {item.user_educations_end_date ?? 'Sekarang'}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='d-grid gap-4'>
              <h5>INFORMASI PENGALAMAN</h5>
              {data?.experiences?.map((item: any, key: any) => (
                <div key={key}>
                  <p className='fw-bold'>{item.user_experiences_title}</p>
                  <p>{item.user_experiences_company_name}</p>
                  <p>
                    {item.user_experiences_start_date} -{' '}
                    {item.user_experiences_end_date ?? 'Sekarang'}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='d-grid gap-4'>
              <h5>INFORMASI KEAHLIAN</h5>
              {data?.skills?.map((item: any, key: any) => (
                <div key={key}>
                  <p className='fw-bold'>{item.skill?.skills_name}</p>
                  <p>{item.user_skills_total_experience} Tahun</p>
                  <p>
                    {item.user_skills_document ? 'Dengan' : 'Tanpa'} Sertifikat{' '}
                    {item.user_skills_institution ? `- ${item.user_skills_institution}` : null}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='d-grid gap-4'>
              <h5>INFORMASI BAHASA</h5>
              {data?.languages?.map((item: any, key: any) => (
                <div key={key}>
                  <p className='fw-bold'>{item.language?.languages_name}</p>
                  <p>
                    Percakapan {item.speaking.proficiencies_description}, Membaca{' '}
                    {item.reading.proficiencies_description}, Menulis{' '}
                    {item.writing.proficiencies_description}
                  </p>
                  <p>
                    {item.user_languages_document ? 'Dengan' : 'Tanpa'} Sertifikat{' '}
                    {item.user_languages_institution
                      ? `- ${item.user_languages_institution}`
                      : null}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className='col-md-12'>
          <div className='card-custom'>
            <div className='d-grid gap-4'>
              <h5>INFORMASI LAINNYA</h5>
              {data?.others?.map((item: any, key: any) => (
                <div key={key}>
                  <p className='fw-bold'>{item.user_others_title}</p>
                  <p>{item.user_others_description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
